import React from 'react';
import {SubscriptionExpiryBanner} from '../components/SubscriptionExpiryBanner';
import {Header} from './Header';

export const LayoutTop = () => (
    <>
        <SubscriptionExpiryBanner/>
        <Header/>
    </>
);
